import { combineReducers } from 'redux';

import channels from './channels';
import featureFlag from './featureFlag';
import limits from './limits';
import metrics from './metrics';
import sharedData from './sharedData';
import timePeriods from './timePeriods';
import userData from './userData';

export default combineReducers({
  timePeriods,
  channels,
  limits,
  userData,
  sharedData,
  metrics,
  featureFlag,
});



// WEBPACK FOOTER //
// ./src/JourneyBuilder/SendOptimizer/reducers/index.js